<template>
  <div class="container">
    <!-- 顶部区域 -->
    <head-bar @passByValue="passByValue"></head-bar>
    <!-- 导航菜单栏 -->
    <nav-bar :menuCode="topMenuCode"></nav-bar>
    <!-- 主内容区域 -->
    <main-content></main-content>
  </div>
</template>

<script>
import HeadBar from "./Home/HeadBar"
import NavBar from "./Home/NavBar"
import MainContent from "./Home/MainContent"

export default {
  components: {
    HeadBar,
    NavBar,
    MainContent
  },
  data() {
    return {
      flag: false,
      topMenuCode: '',
    }
  },
  methods: {
    passByValue: function (data) {
      this.topMenuCode = data;
    },
  }
};
</script>

<style scoped lang="scss">
.container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  // background: rgba(224, 234, 235, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue